<template>
  <div v-if="showSearchItems">
    <v-chip
      v-for="(searchItem, index) in searchItems"
      class="my-2 mr-4 caption"
      outlined
      :title="searchItem.val"
      :color="searchItem.color"
      :key="index"
    >
      {{ truncate(searchItem.val, 40) }}
      <v-avatar right v-if="!searchItem.default">
        <v-icon
          @click="removeSearchItem(searchItem, index)"
          class="advanceSearchLabel"
          :data-test-id="`chip-${index + 1}__close-icon`"
          >close</v-icon
        >
      </v-avatar>
    </v-chip>
    <v-chip
      @click="() => this.$emit('cancelSearch')"
      class="my-2 caption"
      outlined
      v-if="searchItems.length"
      data-test-id="clear-all-chip"
    >
      Clear all
      <v-avatar right>
        <v-icon class="advanceSearchLabel">close</v-icon>
      </v-avatar>
    </v-chip>
  </div>
</template>
<script>
export default {
  name: 'AdvanceSearchFiltersBox',
  props: ['showSearchItems', 'searchItems'],
  methods: {
    removeSearchItem(searchItem, index) {
      this.$emit('removeSearchItem', { item: searchItem, index });
    }
  }
};
</script>
<style scoped>
.v-icon {
  cursor: pointer;
}
.v-chip.v-size--default {
  border-radius: 4px;
}
.advanceSearchLabel {
  font-size: 12px !important;
  font-weight: 700;
}
</style>
